import React, { useState, useEffect } from "react";
import { AiOutlineUsergroupAdd, AiOutlineSearch } from "react-icons/ai";
import DataTable from "react-data-table-component";
import OffCanvas from "../../../OffCanvas/OffCanvas";
import InvitesTab from "./InvitesTab/InvitesTab";
import ViewInvites from "./ViewInvites";
import ModalDelete from "../../../Modal/ModalDelete";
import DeleteForm from "./DeleteForm";
import useCustomFecthQuery from "../../../../Hooks/useCustomFecthQuery";
import useCustomMutation from "../../../../Hooks/useCustomMutation";

const Invites = ({ userID, token, eventID }) => {
  const [isOffcanvasOpen, setIsOffcanvasOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [attendeeID, setAttendeeID] = useState(null);
  const [attendEmail, setAttendeeEmail] = useState(null);
  const [attendDetails, setAttendeeDetails] = useState(null);
  const [isToggleView, setIsToggleView] = useState(false);
  const [isToggleDelete, setIsToggleDelete] = useState(false);
  const key = ["myInvites", eventID];

  const mutationDelete = useCustomMutation(key);

  const {
    data: inviteResponse,
    error: errorGetInvitees,
    isLoading: isLoadingGetInvitees,
  } = useCustomFecthQuery(
    key,
    `${process.env.REACT_APP_API}event-invitations/invite/${eventID}`,
    token,
    { enabled: !!eventID }
  );

  const handleSearch = (event) => setSearch(event.target.value);
  const handleOpenOffCanvas = () => setIsOffcanvasOpen(!isOffcanvasOpen);

  const tog_viewParticipant = (details) => {
    setAttendeeDetails(details);
    setIsToggleView(!isToggleView);
  };

  const tog_deleteParticipant = (id, email) => {
    setAttendeeID(id);
    setAttendeeEmail(email);
    setIsToggleDelete(!isToggleDelete);
  };

  const DeleteParticipant = () => {
    const data = {
      endPoint: `attendees/${attendeeID}/?eventId=${eventID}&email=${attendEmail}`,
      bodyContent: null,
      Method: "DELETE",
      displayMessage: "Attendee successfully deleted",
      token: token,
      isJSON: null,
    };
    mutationDelete.mutate(data);
  };

  const filterParticipants = (participants, searchQuery) => {
    if (!searchQuery || !participants) return participants || [];
    return participants?.filter((item) =>
      [item?.firstName, item?.lastName, item?.email, item?.jobTitle].some(
        (field) => field?.toLowerCase().includes(searchQuery.toLowerCase())
      )
    );
  };

  const rawData = inviteResponse?.data || inviteResponse || [];
  const participants = Array.isArray(rawData) ? rawData : [];
  const filteredAttendees = filterParticipants(participants, search);
  const data = filteredAttendees || [];

  useEffect(() => {
    if (mutationDelete.isSuccess) setIsToggleDelete(false);
  }, [mutationDelete.isSuccess]);

  const columns = [
    {
      name: <span style={{ fontWeight: '700', color: '#374151', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Email</span>,
      selector: (row) => row?.email || 'N/A',
      sortable: true,
      width: '220px',
      cell: (row) => (
        <div style={{ 
          overflow: 'hidden', 
          textOverflow: 'ellipsis', 
          whiteSpace: 'nowrap', 
          fontSize: '13px',
          color: '#1f2937',
          fontWeight: '500'
        }} title={row?.email}>
          {row?.email || 'N/A'}
        </div>
      ),
    },
    {
      name: <span style={{ fontWeight: '700', color: '#374151', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Status</span>,
      cell: () => (
        <span style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '6px',
          padding: '6px 12px',
          background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
          color: '#ffffff',
          fontSize: '11px',
          fontWeight: '600',
          borderRadius: '20px',
          boxShadow: '0 2px 4px rgba(16, 185, 129, 0.3)',
          textTransform: 'uppercase',
          letterSpacing: '0.3px'
        }}>
          <span style={{ 
            width: '6px', 
            height: '6px', 
            background: '#ffffff', 
            borderRadius: '50%',
            animation: 'pulse 2s infinite'
          }}></span>
          Invitation Sent
        </span>
      ),
      width: '220px',
      center: true,
    },
  ];

  const customStyles = {
    table: { 
      style: { 
        width: '100%',
        backgroundColor: '#ffffff',
      } 
    },
    tableWrapper: {
      style: {
        width: '100%',
        overflowX: 'auto',
      }
    },
    header: {
      style: {
        backgroundColor: '#ffffff',
        padding: '16px 20px',
      }
    },
    headRow: { 
      style: { 
        backgroundColor: '#f9fafb',
        borderBottom: '2px solid #e5e7eb',
        minHeight: '48px',
        borderTop: '1px solid #e5e7eb',
      } 
    },
    headCells: { 
      style: { 
        fontSize: '12px',
        fontWeight: '700',
        padding: '14px 16px',
        color: '#374151',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
      } 
    },
    cells: { 
      style: { 
        padding: '14px 16px',
        fontSize: '13px',
        color: '#6b7280',
      } 
    },
    rows: { 
      style: { 
        '&:hover': {
          backgroundColor: '#f9fafb',
          transition: 'background-color 0.2s ease',
        },
        '&:not(:last-of-type)': {
          borderBottom: '1px solid #f3f4f6',
        },
        transition: 'all 0.2s ease',
      } 
    },
    pagination: { 
      style: { 
        backgroundColor: '#ffffff',
        borderTop: '1px solid #e5e7eb',
        fontSize: '12px',
        padding: '12px 16px',
        minHeight: '60px',
      },
      pageButtonsStyle: {
        borderRadius: '8px',
        height: '36px',
        width: '36px',
        minWidth: '36px',
        margin: '0 2px',
        color: '#6b7280',
        backgroundColor: '#f9fafb',
        border: '1px solid #e5e7eb',
        fontSize: '13px',
        fontWeight: '500',
        transition: 'all 0.2s ease',
        '&:hover:not(:disabled)': {
          backgroundColor: '#f68a20',
          color: '#ffffff',
          borderColor: '#f68a20',
          transform: 'translateY(-1px)',
          boxShadow: '0 4px 8px rgba(246, 138, 32, 0.3)',
        },
        '&:disabled': {
          color: '#d1d5db',
          cursor: 'not-allowed',
          backgroundColor: '#f3f4f6',
        },
        '&[aria-current="page"]': {
          backgroundColor: '#f68a20',
          color: '#ffffff',
          borderColor: '#f68a20',
          fontWeight: '600',
        },
      },
    },
    noData: {
      style: {
        padding: '40px 20px',
        textAlign: 'center',
      }
    },
  };

  return (
    <div style={{ width: '100%', minHeight: '100vh', background: 'linear-gradient(180deg, #f9fafb 0%, #f3f4f6 100%)', padding: '24px 0 32px', boxSizing: 'border-box' }}>
      <div style={{ width: '100%', maxWidth: '100%', margin: '0 auto', padding: '0 20px', boxSizing: 'border-box', overflow: 'hidden' }}>
        {/* Header */}
        <div style={{ marginBottom: '24px', paddingBottom: '16px', borderBottom: '2px solid #e5e7eb' }}>
          <h1 style={{ fontSize: '24px', fontWeight: '700', color: '#111827', margin: '0 0 8px 0', letterSpacing: '-0.5px' }}>Invitations</h1>
          <p style={{ fontSize: '14px', color: '#6b7280', margin: 0, lineHeight: '1.5' }}>Manage all invited attendees and track invitation status</p>
        </div>

        {/* Search + Button */}
        <div style={{ display: 'flex', gap: '12px', alignItems: 'stretch', marginBottom: '20px', flexWrap: 'wrap', width: '100%' }}>
          <div style={{ flex: 1, minWidth: '240px', position: 'relative', maxWidth: '100%' }}>
            <AiOutlineSearch style={{ position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)', color: '#9ca3af', fontSize: '18px', pointerEvents: 'none', zIndex: 2 }} />
            <input
              type="text"
              placeholder="Search attendees by name or email..."
              value={search}
              onChange={handleSearch}
              style={{ 
                width: '100%', 
                padding: '12px 40px 12px 44px', 
                border: '2px solid #e5e7eb', 
                borderRadius: '12px', 
                fontSize: '14px', 
                background: '#ffffff', 
                color: '#1f2937', 
                boxSizing: 'border-box', 
                height: '48px',
                transition: 'all 0.2s ease',
                fontWeight: '400',
              }}
              onFocus={(e) => {
                e.target.style.borderColor = '#f68a20';
                e.target.style.boxShadow = '0 0 0 4px rgba(246, 138, 32, 0.1)';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = '#e5e7eb';
                e.target.style.boxShadow = 'none';
              }}
            />
            {search && (
              <button type="button" onClick={() => setSearch("")} style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', background: '#f3f4f6', border: 'none', width: '28px', height: '28px', borderRadius: '50%', color: '#6b7280', fontSize: '18px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2, transition: 'all 0.2s ease' }}
                onMouseEnter={(e) => {
                  e.target.style.background = '#e5e7eb';
                  e.target.style.color = '#374151';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = '#f3f4f6';
                  e.target.style.color = '#6b7280';
                }}
              >
                ×
              </button>
            )}
          </div>
          <button type="button" onClick={handleOpenOffCanvas} style={{ 
            display: 'inline-flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            gap: '8px', 
            padding: '12px 24px', 
            background: 'linear-gradient(135deg, #f68a20 0%, #e57a10 100%)', 
            color: '#ffffff', 
            border: 'none', 
            borderRadius: '12px', 
            fontSize: '14px', 
            fontWeight: '600', 
            cursor: 'pointer', 
            height: '48px', 
            flexShrink: 0,
            boxShadow: '0 4px 12px rgba(246, 138, 32, 0.3)',
            transition: 'all 0.2s ease',
          }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 6px 16px rgba(246, 138, 32, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 12px rgba(246, 138, 32, 0.3)';
            }}
          >
            <AiOutlineUsergroupAdd size={18} />
            <span>Invite Attendee</span>
          </button>
        </div>

        {/* Table Card */}
        <div style={{ 
          width: '100%', 
          background: '#ffffff', 
          borderRadius: '16px', 
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.06)',
          border: '1px solid #e5e7eb', 
          boxSizing: 'border-box', 
          overflow: 'hidden',
        }}>
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center', 
            padding: '16px 20px', 
            background: 'linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%)',
            borderBottom: '2px solid #e5e7eb',
            flexWrap: 'wrap', 
            gap: '12px',
          }}>
            <span style={{ fontSize: '15px', fontWeight: '700', color: '#111827', letterSpacing: '-0.2px' }}>Attendee List</span>
            <span style={{ 
              fontSize: '13px', 
              color: '#6b7280',
              padding: '6px 12px',
              background: '#ffffff',
              borderRadius: '8px',
              border: '1px solid #e5e7eb',
              fontWeight: '500',
            }}>
              {search ? `Searching: "${search}"` : `${data.length} attendees`}
            </span>
          </div>
          
          {/* Table wrapper with containment */}
          <div style={{ width: '100%', overflowX: 'auto', overflowY: 'hidden', WebkitOverflowScrolling: 'touch', position: 'relative' }}>
            <div style={{ minWidth: '380px' }}>
              {isLoadingGetInvitees ? (
                <div className="text-center p-3">
                  <div className="spinner-border text-primary" role="status" style={{ width: '2rem', height: '2rem', borderWidth: '3px' }}>
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="mt-3 mb-0" style={{ fontSize: '14px', color: '#6b7280', fontWeight: '500' }}>Loading attendees...</p>
                </div>
              ) : errorGetInvitees ? (
                <div className="text-center p-3" style={{ padding: '60px 20px' }}>
                  <div className="mb-3" style={{ fontSize: "48px" }}>❌</div>
                  <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#111827', margin: '0 0 8px 0' }}>Error loading data</h3>
                  <p className="text-muted mb-0" style={{ fontSize: '13px', color: '#6b7280' }}>Please try again later</p>
                </div>
              ) : data.length === 0 ? (
                <div className="text-center p-3" style={{ padding: '60px 20px' }}>
                  <div className="mb-3" style={{ fontSize: "64px", opacity: '0.5' }}>📭</div>
                  <h3 style={{ fontSize: '18px', fontWeight: '600', color: '#111827', margin: '0 0 8px 0' }}>No attendees yet</h3>
                  <p className="text-muted mb-0" style={{ fontSize: '14px', color: '#6b7280' }}>
                    {search ? `No results found for "${search}"` : 'Start by inviting your first attendee'}
                  </p>
                </div>
              ) : (
                <DataTable
                  columns={columns}
                  data={data}
                  pagination
                  paginationPerPage={10}
                  paginationRowsPerPageOptions={[10, 25, 50]}
                  highlightOnHover
                  pointerOnHover
                  customStyles={customStyles}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      <OffCanvas isOffcanvasOpen={isOffcanvasOpen} title="Invite Attendee" body={<InvitesTab userID={userID} token={token} eventID={eventID} setIsOffcanvasOpen={setIsOffcanvasOpen} />} toggleSaveChanges={handleOpenOffCanvas} directionOffCanvas="end" widthOffCanvas={700} />
      <OffCanvas isOffcanvasOpen={isToggleView} title="Attendee Details" body={<ViewInvites details={attendDetails} />} toggleSaveChanges={() => tog_viewParticipant()} directionOffCanvas="end" widthOffCanvas={400} />
      <ModalDelete size="md" isOpen={isToggleDelete} toggle={() => setIsToggleDelete(false)} title="Delete Invite" body={<DeleteForm setIsToggleDelete={setIsToggleDelete} DeleteParticitant={DeleteParticipant} pending={mutationDelete?.isLoading} />} />

      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
        
        .badge { display: inline-block; padding: 0.25em 0.4em; font-size: 75%; font-weight: 700; line-height: 1; text-align: center; white-space: nowrap; vertical-align: baseline; border-radius: 0.25rem; }
        .bg-success { background-color: #59CE96 !important; color: #fff !important; }
        .text-center { text-align: center !important; }
        .text-muted { color: #6b7280 !important; }
        .p-3 { padding: 1rem !important; }
        .spinner-border { display: inline-block; width: 1rem; height: 1rem; border: 0.2em solid currentColor; border-right-color: transparent; border-radius: 50%; animation: spinner-border 0.75s linear infinite; }
        @keyframes spinner-border { to { transform: rotate(360deg); } }
        .visually-hidden { position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0,0,0,0); white-space: nowrap; border: 0; }
        
        /* Custom scrollbar */
        div::-webkit-scrollbar { height: 8px; }
        div::-webkit-scrollbar-track { background: #f1f3f5; border-radius: 4px; }
        div::-webkit-scrollbar-thumb { background: linear-gradient(180deg, #c1c9d2 0%, #9aa5b1 100%); border-radius: 4px; }
        div::-webkit-scrollbar-thumb:hover { background: linear-gradient(180deg, #9aa5b1 0%, #6b7280 100%); }
        
        @media (max-width: 768px) {
          div[style*="padding: 0 20px"] { padding: 0 16px !important; }
        }
        
        @media (max-width: 480px) {
          div[style*="padding: 0 20px"] { padding: 0 12px !important; }
        }
      `}
      
      </style>
    </div>
  );
};
export default Invites;